import { Modal } from '../../../../components/Modal';
import styles from './styles.module.scss';
import { SwiperSlider } from '../../../../components/SwiperSlider';
import { FC } from 'react';
import FirstHintImage from '../../../../assets/images/fragments/FirstHint.jpg';
import SecondHintImage from '../../../../assets/images/fragments/SecondHint.png';
import ThirdHintImage from '../../../../assets/images/fragments/ThirdHint.jpg';
import LevelImage from '../../../../assets/images/fragments/Level.svg';

type TRulesModalProps = {
  onClose: () => void;
};

const slides = [
  {
    id: 1,
    text: (
      <p className={styles.firstText}>
        ⁠Что загадано на картинке?
        <br />
        Попробуй отгадать по фрагменту!
      </p>
    ),
    image: <img alt="Неполный фрагмент" className={styles.firstImage} src={FirstHintImage} />,
  },
  {
    id: 2,
    text: <p className={styles.secondText}>Собери название объекта из предложенных букв.</p>,
    image: <img alt="Набор букв" className={styles.secondImage} src={SecondHintImage} />,
  },
  {
    id: 3,
    text: (
      <div className={styles.thirdText}>
        <p> Чтобы открыть скрытую часть картинки, нажми на нее.</p>
        <br />
        <p className={styles.secondParagraph}>
          Но будь внимателен: количество подсказок ограничено
          <img alt="" src={LevelImage} className={styles.levelImage} />
        </p>
      </div>
    ),
    image: <img alt="Полный фрагмент" className={styles.thirdImage} src={ThirdHintImage} />,
  },
];

const RulesModal: FC<TRulesModalProps> = ({ onClose }) => {
  return (
    <Modal onClose={onClose} variant="fragments" closeOnOverlayClick={false}>
      <SwiperSlider variant="fragments" spaceBetween={0} slidesPerView={1}>
        {slides.map((slide) => {
          return (
            <div key={slide.id} className={styles.slide}>
              {slide.image}
              <div className={styles.text}>{slide.text}</div>
            </div>
          );
        })}
      </SwiperSlider>
    </Modal>
  );
};

export default RulesModal;
